import React from 'react';
import './about.css';

const AboutUs = () => {
  return (
    <div className="page about-us-page">

      {/* ===== हेडर ===== */}
      <header className="page-header">
        <h1>गट ग्रामपंचायत खापरी-उबगी : प्रगतीचा संकल्प</h1>
        <p className="page-intro">
          गट ग्रामपंचायत खापरी-उबगी कळमेश्वर तालुक्यातील एक प्रगतिशील गाव आहे. आम्ही स्वच्छ, डिजिटल आणि आत्मनिर्भर गाव बनवण्यासाठी कटिबद्ध आहोत.
        </p>
      </header>

      <main className="page-content-grid">

        {/* ===== १. आमची दृष्टी ===== */}
        <section className="section vision-section">
          <h2>आमची दृष्टी (Our Vision)</h2>
          <div className="vision-cards-container">
            <div className="vision-card"><div className="vision-icon">World</div><h4>डिजिटल ग्राम</h4><p>पारदर्शक आणि डिजिटल कामकाज</p></div>
            <div className="vision-card"><div className="vision-icon">Leaf</div><h4>पर्यावरण पूरक विकास</h4><p>स्वच्छता आणि पाणी व्यवस्थापन</p></div>
            <div className="vision-card"><div className="vision-icon">Handshake</div><h4>युवा-महिला सशक्तीकरण</h4><p>शिक्षण, आरोग्य व रोजगार</p></div>
          </div>
        </section>

        {/* ===== २. गावाची मूलभूत माहिती (फोटोमधील टेबल + तुम्ही सांगितलेली माहिती) ===== */}
        <section className="section stats-section">
          <h2 className="section-title">गावाची मूलभूत माहिती</h2>
          
          <div className="stats-table-container">
            <table className="stats-table">
              <thead>
                <tr>
                  <th>अ.क्र.</th>
                  <th>तपशील</th>
                  <th>स्त्री</th>
                  <th>पुरुष</th>
                  <th>एकूण</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>१</td><td>एकूण कुटुंब संख्या</td><td>-</td><td>-</td><td><strong>328</strong></td></tr>
                <tr><td>२</td><td>एकूण लोकसंख्या</td><td>868</td><td>971</td><td><strong>1,839</strong></td></tr>
                <tr><td>३</td><td>एकूण मुलांची संख्या </td><td>91 </td><td>94</td><td><strong>185</strong></td></tr>
                <tr><td>४</td><td>अनुसूचित जाती</td><td>32</td><td>40</td><td><strong>72</strong></td></tr>
                <tr><td>५</td><td>अनुसूचित जमाती</td><td>229</td><td>288</td><td><strong>571</strong></td></tr>
                <tr><td>६</td><td>एकूण कामगार</td><td>386</td><td>469</td><td><strong>853</strong></td></tr>
                <tr><td>७</td><td>एकूण साक्षरता</td><td>82.67%</td><td>85.92%</td><td><strong>89.87%</strong></td></tr>
              </tbody>
            </table>
          </div>

          {/* ===== अतिरिक्त माहिती (तुम्ही सांगितलेली) ===== */}
          <div className="extra-info-grid">
            <div className="info-card">
              <h4>एकूण मतदार संख्या</h4>
              <p className="big-number">१,११०</p>
            </div>
            <div className="info-card">
              <h4>शौचालय सुविधा</h4>
              <p className="big-number success">१००%</p>
            </div>
            <div className="info-card">
              <h4>नळ पाणी योजना</h4>
              <p>विहीर: ३</p>
            </div>
            <div className="info-card">
              <h4>हातपंप</h4>
              <p className="big-number">२</p>
            </div>
            <div className="info-card">
              <h4>बायोगॅस प्रकल्प</h4>
              <p className="big-number">२</p>
            </div>
            <div className="info-card">
              <h4>पाण्याच्या टाक्या</h4>
              <p>खापरी: १ (४०,००० लि.)<br/>उबगी: १ (४०,००० लि.)</p>
            </div>
            <div className="info-card">
              <h4>शासकीय प्राथमिक शाळा</h4>
              <p className="big-number">३</p>
            </div>
            <div className="info-card">
              <h4>बचत गट</h4>
              <p>खापरी: १२<br/>उबगी: ८<br/><strong>एकूण २०</strong></p>
            </div>
            <div className="info-card">
              <h4>व्यायाम शाळा (Open Gym)</h4>
              <p className="big-number success">१</p>
            </div>
            <div className="info-card full-width">
              <h4>गावाचे भौगोलिक क्षेत्रफळ (हेक्टरमध्ये)</h4>
              <p>खापरी: <strong>405.77</strong> हे.<br/>
                 उबगी: <strong>708.30</strong> हे.<br/>
                 बोर्ड रिठी: <strong>174.96</strong> हे.<br/>
                 <strong>एकूण क्षेत्रफळ: १,२८९.०३ हेक्टर</strong></p>
            </div>
          </div>
        </section>

        {/* ===== ३. सेवा आणि सुविधा ===== */}
        <section className="section services-section">
          <h2>सेवा आणि सुविधा</h2>
          <ul className="service-list">
            <li>उत्तम रस्ते, २४×७ पाणीपुरवठा</li>
            <li>जन्म-मृत्यू, रहिवासी दाखले ४८ तासांत</li>
            <li>सर्व शासकीय योजनांचा लाभ थेट घरी</li>
            <li>१००% शौचालय युक्त गाव</li>
            <li>महिला बचत गटांना प्रोत्साहन</li>
          </ul>
        </section>

        {/* ===== ४. सरपंच संदेश ===== */}
        <section className="section sarpanch-section bg-light">
          <h2>सरपंचांचा संदेश</h2>
          <div className="sarpanch-card">
            <h3>श्रीमती मधुमती देवदास तागडे</h3>
            <p className="slogan">“प्रत्येक नागरिकाच्या आवाजाला महत्त्व”</p>
            <p>
              मी गट ग्रामपंचायत खापरी-उबगी ची जबाबदारी स्वीकारताना वचन देतो की, ग्रामपंचायतीचे दरवाजे प्रत्येकासाठी खुले राहतील. 
              आमचा कारभार जनता-केंद्रित आहे. स्वच्छता, पाणी, शिक्षण आणि रोजगार या चार स्तंभांवर आम्ही गावाचा विकास करीत आहोत.
            </p>
          </div>
        </section>

      </main>

      <footer className="page-footer">
        <p>गट ग्रामपंचायत खापरी-उबगी – एक स्वच्छ, हिरवे आणि डिजिटल गाव </p>
      </footer>
    </div>
  );
};

export default AboutUs;